import Vue from 'vue'
import VueRouter from 'vue-router'
import Coupon from './views/Coupons.vue'
import Login from './views/Login.vue'


import * as firebase from "firebase/app";
import "firebase/auth";

Vue.use(VueRouter)


const routes = [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/coupon',
      name: 'coupon',
      component: Coupon,
      meta: { requiresAuth: true }
    },  
  ];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  const isAuthenticated = firebase.auth().currentUser;
  console.log("isauthenticated", isAuthenticated);
  if (requiresAuth && !isAuthenticated) {
    next("/coupon");
  } else {
    next();
  }
});

export default router;